import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import MarketTicker from './MarketTicker';
import Arrow from './Arrow';
import { TiltedCard } from '../reactbits';

export default function PulseTeaser({ post }) {
  const { t } = useLanguage();
  if (!post) return <p className="loading">{t('pulse.empty')}</p>;

  const dateLabel = new Date(post.date).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

  return (
    <TiltedCard className="window" rotateAmplitude={7}>
      <div className="window__bar" aria-hidden>
        <span className="window__dot" />
        <span className="window__dot" />
        <span className="window__dot" />
        <span className="window__url">napho.in/market-pulse</span>
      </div>

      <div className="window__body pulse-card">
        <MarketTicker market={post.market} />
        <div className="pulse-card__meta" style={{ marginTop: '0.6rem' }}>
          <span>{dateLabel}</span>
          <span>·</span>
          <span>{post.readingMinutes} min read</span>
          {(post.tags || []).slice(0, 2).map((tag) => (
            <span className="tag" key={tag}>{tag}</span>
          ))}
        </div>
        <h3 style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: '1.45rem', margin: 0 }}>
          {post.title}
        </h3>
        <div className="pulse-teaser__fade">
          <p>{post.summary}</p>
          {post.body?.[0] && <p className="mt-2">{post.body[0]}</p>}
        </div>
        <Link to={`/market-pulse/${post.slug}`} className="btn btn--primary" style={{ alignSelf: 'flex-start' }}>
          {t('cta.readPulse')} <Arrow className="btn__arrow" />
        </Link>
      </div>
    </TiltedCard>
  );
}
